export default {
    data () {
        return {
            sseController: null
        };
    },
    methods: {
        assistantChat (item) {
            let modelItem = {
                value: 'assistantMode',
                title: item.assistantName + '-' + item.modelName
            };
            this.$store.commit('appSettings/setCurrentAssistant', item);
            this.model = 'assistantMode';
            this.$bus.$emit('setModelData', modelItem);
        },
        assistantAsk (data) {
            if (this.ui.typing) return;
            console.log(this.$store.state.appSettings.curAssistant);
            let curAssistant = this.$store.state.appSettings.curAssistant;
            let prompt = data.input;
            let useLLM = this.useLLM;
            this.prompt = '';
            this.addAsk(prompt);
            let sseMsg = {};
            let apiType = '';
            // 提示词问答
            if (curAssistant.modelType === 'PT') {
                apiType = 'default';
                sseMsg = {
                    'message': prompt,
                    templateCode: curAssistant.modelId
                    // debugAssistantId: curAssistant.assistantId,
                    // 'model': useLLM,
                    // 'stop': ['\r\n\r\nHuman', '\r\nHuman', '\n\nHuman', '\nHuman'], // 流式停止标识
                    // contextLimit: this.modelSettings.contextLimit,
                    // temperature: this.modelSettings.temperature,
                    // maxTokens: this.modelSettings.maxLength
                };
            } else {
                // 计划
                apiType = 'plan';
                sseMsg = {
                    'question': prompt,
                    planCode: curAssistant.modelId
                    // debugPlanParam: {
                    //     debugAssistantId: curAssistant.assistantId,
                    //     'model': useLLM,
                    //     'stop': ['\r\n\r\nHuman', '\r\nHuman', '\n\nHuman', '\nHuman'], // 流式停止标识
                    //     contextLimit: this.modelSettings.contextLimit,
                    //     temperature: this.modelSettings.temperature,
                    //     maxTokens: this.modelSettings.maxLength
                    // }
                };
            }

            // 开始等待打字
            this.ui.typing = true;
            this.currentChat.messages.push({ role: 'assistant', content: '', feedback: null, finished: false });
            this.sendSseStream(sseMsg, apiType);
        }
    }
};
